import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

import { AngularFirestore } from '@angular/fire/firestore';  // Firebase modules for Database, Data list and Single object
import { CategoryExpense } from "./category-expense.model";
import { AuthService } from "app/core/auth.service";

@Injectable()
export class CategoriesExpensesService implements Resolve<any> {

  onCategoriesChanged: BehaviorSubject<any>;


  constructor(
    private afs: AngularFirestore,
    private authService: AuthService
  ) {

    this.onCategoriesChanged = new BehaviorSubject({});

  }

  get uid() {
      return this.authService.user.uid;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise((resolve, reject) => {

      Promise.all([
        this.getCategories(),
        // this.getCuentas(),
        // this.getCurrencies()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  /**
     * Get categories
     *
     * @returns {Promise<any>}
     */
  getCategories(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.afs.collection('categories_expenses', ref => ref.where("uid", "==", this.uid))
        .snapshotChanges()
        .subscribe((categoriasSnapshot) => {
          let _categorias = [];

          categoriasSnapshot.forEach((categoria: any) => {
            _categorias.push({
              id: categoria.payload.doc.id,
              color: categoria.payload.doc.data().color,
              name: categoria.payload.doc.data().name
            });
          });

          this.onCategoriesChanged.next(_categorias);
          resolve(_categorias);
        }, reject);
    });
  }

  // Create Category
  addCategoryExpense(category: CategoryExpense): Observable<any> {
    return new Observable((observer) => {
      this.afs.collection('categories_expenses').add({
        name: category.name,
        color: category.color,
        uid: this.uid
      }
      ).then(function () {
        observer.next();
      }).catch(function (err) {
        console.log('Error Add Category Exprense ', err);
      });
    });
  }

  /**
   * Add new category
   * @param category to add on the account
   */
  addCategorysRegistration(category: CategoryExpense) {
    this.afs.collection('categories_expenses').add({
      name: category.name,
      color: category.color,
      uid: this.uid
    });
  }

  /**
     * Delete category
     */
  deleteCategory(category: CategoryExpense): Observable<boolean> {
    return new Observable((observer) => {
      this.afs.collection("categories_expenses").doc(category.id).delete().then(() => {
        observer.next();
      });
    })
  }

  /**
     * Update category
     *
     * @param CategoryExpense
     * @returns {Observable<any>}
     */
  updateCategory(category: CategoryExpense): Observable<any> {
    return new Observable((observer) => {
      var accountRef = this.afs.collection("categories_expenses").doc(category.id);
      accountRef.update({
        name: category.name,
        color: category.color
      })
        .then(function () {
          observer.next();
        });
    });
  }
}
